exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".titled-card-header label {\n  font-size: 1rem !important;\n  padding-top: 10px !important;\n  margin-bottom: 2px;\n  display: inline-block;\n}\n.titled-card {\n  padding: 10px 0;\n  width: 100%;\n}\n.titled-card .grid {\n  margin-bottom: 10px !important;\n}\n.titled-card .right-items-container {\n  display: flex !important;\n  justify-content: flex-end;\n}\n.titled-card.tight {\n  margin: 0 !important;\n  margin-top: 0.25em !important;\n  padding: 0 !important;\n}\n.titled-card.tight > .ui.card {\n  margin-top: 0.25em !important;\n  margin-bottom: 0.25em !important;\n}\n.titled-card .accordion-title {\n  margin-top: 5px;\n  height: 35px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/styles/components/titled-card.less
// module id = 2621
// module chunks = 0